import React from 'react';
import { Outlet } from 'react-router-dom';
import '../alert/Alert.css';

/**
 * Shell component for App Support so nested routes render inside the shared layout.
 */
export default function AppSupport() {
    return (
        <div className="alert-shell">
            <Outlet />
        </div>
    );
}
